<script setup lang="ts">
useHead({
  bodyAttrs: {
    class: 'bg-surface-secondary',
  },
})

definePageMeta({
  name: 'templates-index',
  layout: 'default',
  colorMode: 'light',
  theme: 'blurple',
  breadcrumb: { label: 'Maler' },
  title: 'Maler',
})

const { toggleFavorite, isFavorite, isFavoriteEnabled } = useFavorites()
const { templates, numFound, isLoading, searchKeyword, selectedLegalArea, selectedAuthor, showOnlyFavorites } = useTemplateFilters()

const openMobileFilter = ref<boolean>(false)

const route = useRoute<'templates-index'>()
const visibleCount = ref(50)
const visibleTemplates = computed(() => templates.value.slice(0, visibleCount.value))
const canShowMore = computed(() => visibleCount.value < templates.value.length)

const hasActiveFilters = computed(() => searchKeyword.value.length > 0 || selectedLegalArea.value.length > 0 || selectedAuthor.value.length > 0 || showOnlyFavorites.value)

function showMore() {
  visibleCount.value += 50
}

watch(templates, () => {
  visibleCount.value = 50
})

const toggleFavoriteForTemplates = (id: string) => toggleFavorite('templates', id)

useTrackLastActivity(() => String(route.meta.title))
</script>

<template>
  <NuxtLayout name="overview-with-bread-crumbs-and-title" page-title="Maler" sticky-panel-top>
    <template #background-illustration>
      <IllustrationMaler class="translate-y-[7%]" />
    </template>

    <div class="w-full flex items-start gap-l">
      <StickyContent class="hidden lg:flex flex-col shrink-0 max-h-[calc(100dvh-6.5rem)] no-scrollbar overflow-y-auto [--padding-top:0rem]">
        <TemplatesFilterSidebar />
      </StickyContent>

      <div class="flex-1 min-w-0 flex flex-col gap-2xs">
        <StickyContent class="bg-white z-10 pt-m">
          <TemplatesListHeader v-model:open-filter="openMobileFilter" />
        </StickyContent>

        <h2 class="sr-only">Maler</h2>

        <TemplatesList
          :has-active-filters="hasActiveFilters"
          :is-favorite="isFavorite"
          :is-favorite-enabled="isFavoriteEnabled"
          :is-loading="isLoading"
          :templates="visibleTemplates"
          :toggle-favorite="toggleFavoriteForTemplates"
        />

        <div v-if="!isLoading && canShowMore" class="mt-s flex items-center justify-center">
          <Button variant="primary" size="small" @click="showMore" class="text-blue-600 bg-blue-50 hover:bg-blue-100 px-s py-2xs text-sm font-medium rounded-lg disabled:opacity-50 ">
            Vis flere
          </Button>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>
